/**
 * 外部活动（如闯关）助力任务
 * 仅 taskSource=chuangguan 时会上报完成，不影响项目内原有挖矿任务调用
 */
import { Toast } from 'vant';
import { reqChouqiandone } from '@/api/activity';

/**
 * 业务操作完成后调用：仅 chuangguan 且存在 taskId 时请求完成任务
 * @param {object} [options]
 * @param {string} [options.taskSource]
 * @param {string|number} [options.taskId]
 * @returns {Promise<object|null>}
 */
export async function completeExternalTask(options = {}) {
  const { taskSource, taskId, ...extra } = options;
  if (taskSource !== 'chuangguan' || !taskId) {
    return null;
  }
  const res = await reqChouqiandone({
    id: taskId,
    activityId: 5,
    type: 6,
    ...extra,
  });
  if (res?.code === 0) {
    Toast('任务已完成');
  }else{
    Toast(res.msg);
  }
  return res;
}
